<template>
    <div id="employee-panel-container">
        <b-row>
            <b-col class="col-12">
                <MdTitle
                    v-bind:Text="$t('userHeader.EmployeeInfo')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_EMPLOYEE_SUBTITLE'"
                />

                <MdTabList
                    v-bind:TabList="tablist"
                    v-bind:ShowTabList="false"
                    v-bind:ShowTabEnd="false"
                >
                    <div class="tab-content tab-content-custom-pill" id="pills-tabContent-custom">
                        <!-- BEGIN Employee General Info -->
                        <div class="tab-pane fade show active" id="general" role="tabpanel">
                            <b-row>
                                <b-col lg="3" md="3" sm="12">
                                    <MdSelect
                                        v-bind:Label="$t('Shared.Type')"
                                        v-bind:Options="typeList"
                                        v-bind:Model="editableItem.emptype"
                                        v-bind:FieldDescription="'description'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Multiple="false"
                                        :Input="ChangeDropDownType"
                                        :isRequired="true"
                                        :isValid="isEmployeeTypeValid"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit
                                        v-model="editableItem.title"
                                        v-bind:Label="$t('Patient.Title')"
                                        v-bind:isRequired="false"
                                        v-bind:MaxLengthProp="100"
                                        v-bind:Id="'input_e_t'"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit
                                        v-model="editableItem.employeeId"
                                        v-bind:Label="'Emp ID'"
                                        v-bind:isRequired="false"
                                        v-bind:MaxLengthProp="15"
                                        v-bind:Id="'input_e_id'"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdSelect
                                        v-bind:Label="$t('PharmacyLocations.Location')"
                                        v-bind:Options="branchLocationList"
                                        v-bind:Model="editableItem.branchLocation"
                                        v-bind:FieldDescription="'description'"
                                        v-bind:FieldCode="'code'"
                                        :IsDisabled="false"
                                        v-bind:Multiple="false"
                                        :Input="ChangeDropDownBranchLocation"
                                    />
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit
                                        v-model="editableItem.dayphone"
                                        v-bind:Label="$t('Shared.DayPhone')"
                                        v-bind:isRequired="false"
                                        v-bind:MaxLengthProp="15"
                                        v-bind:Id="'input_e_dph'"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit
                                        v-model="editableItem.nightphone"
                                        v-bind:Label="$t('Shared.NightPhone')"
                                        v-bind:isRequired="false"
                                        v-bind:MaxLengthProp="15"
                                        v-bind:Id="'input_e_nph'"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit
                                        v-model="editableItem.beeper"
                                        v-bind:Label="$t('Shared.CellPhone')"
                                        v-bind:isRequired="false"
                                        v-bind:MaxLengthProp="15"
                                        v-bind:Id="'input_e_cph'"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit
                                        v-model="editableItem.license"
                                        v-bind:Label="$t('employee.DrivLic')"
                                        v-bind:isRequired="false"
                                        v-bind:MaxLengthProp="15"
                                        v-bind:Id="'input_e_licen'"
                                    />
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col lg="3" md="3" sm="12">
                                    <MdSelect
                                        v-bind:Label="$t('employee.phoneComp')"
                                        v-bind:Options="cellCompanyList"
                                        v-bind:Model="editableItem.cellCompany"
                                        v-bind:FieldDescription="'description'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Multiple="false"
                                        :Input="ChangeDropDownCellCompany"
                                        v-bind:Id="'input_e_comph'"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit
                                        v-bind:Label="$t('Shared.SSN')"
                                        v-bind:TypeProp="'text'"
                                        v-bind:Name="'ssn'"
                                        v-bind:MaxLengthProp="10"
                                        v-model="editableItem.ssn"
                                        v-bind:Mask="'###-##-####'"
                                        v-bind:Id="'input_e_ssn'"
                                    >
                                    </MdEdit>
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdDateTime
                                        :Label="$t('Shared.Dob')"
                                        :Model="editableItem.dob"
                                        @input="editableItem.dob = $event"
                                        :Id="'EmployeeDob'"
                                        :Type="'date'"
                                        :isConfirm="false"
                                        :ReadOnly="isReadOnly"
                                        :isValid="isValidDob"
                                    >
                                    </MdDateTime>
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdRadioGroup
                                        v-bind:Label="$t('Shared.Gender')"
                                        v-model="editableItem.sex"
                                        v-bind:Options="GenderList"
                                        v-bind:Name="'Gender'"
                                    />
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col lg="3" md="3" sm="12">
                                    <MdLookup
                                        v-bind:ModelCode="editableItem.taxonomy"
                                        v-bind:ModelDescription="editableItem.taxonomyDescription"
                                        v-bind:Label="$t('Shared.Taxonomy')"
                                        v-bind:RefCode="'Taxonomy'"
                                        v-bind:Fields="BaseFieldsTaxonomy"
                                        v-bind:Api="'GlobalCodes?CodeType=TAXONOMY'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:IsDisabled="false"
                                        v-bind:FieldDescription="'description'"
                                        :SearchTitle="$t('Shared.Taxonomy')"
                                        :GetValues="onCodeConditionOk"
                                        :InvalidFeedback="$t('employee.InvTaxCodeMsg')"
                                        :SearchFieldCode="'Code'"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdSelect
                                        v-bind:Label="$t('Shared.Ethnicity')"
                                        v-bind:Options="ethnicityList"
                                        v-bind:Model="editableItem.ethcode"
                                        v-bind:FieldDescription="'description'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Multiple="false"
                                        :Input="ChangeDropDownEthnicity"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdSelect
                                        v-bind:Label="$t('employee.Credentials')"
                                        v-bind:Options="credentialsList"
                                        v-bind:Model="editableItem.credentials"
                                        v-bind:FieldDescription="'description'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Multiple="false"
                                        :Input="ChangeDropDownCredentials"
                                    />
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col lg="3" md="3" sm="12">
                                    <MdSelect
                                        v-bind:Label="$t('Shared.Status')"
                                        v-bind:Options="StatusList"
                                        v-bind:Model="editableItem.status"
                                        v-bind:FieldDescription="'text'"
                                        v-bind:FieldCode="'value'"
                                        v-bind:Multiple="false"
                                        :Input="ChangeDropDownStatus"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdSelect
                                        v-bind:Label="$t('MdNote.Cosigner')"
                                        v-bind:Options="CosignerList"
                                        v-bind:Model="editableItem.needCoSigner"
                                        v-bind:FieldDescription="'text'"
                                        v-bind:FieldCode="'value'"
                                        v-bind:Multiple="false"
                                        :Input="ChangeDropDownCosigner"
                                        :isRequired="true"
                                        :isValid="isNeedCosignerValid"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdDateTime
                                        :Label="$t('employee.HiredDate')"
                                        :Model="editableItem.hireddate"
                                        @input="editableItem.hireddate = $event"
                                        :Id="'EmployeeHiredDate'"
                                        :Type="'date'"
                                        :isConfirm="false"
                                        :ReadOnly="isReadOnly"
                                        :isValid="isValidHiredDate"
                                    >
                                    </MdDateTime>
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdDateTime
                                        :Label="$t('employee.TerminateDate')"
                                        :Model="editableItem.terminatedate"
                                        @input="editableItem.terminatedate = $event"
                                        :Id="'EmployeeTerminateDate'"
                                        :Type="'date'"
                                        :isConfirm="false"
                                        :ReadOnly="isReadOnlyTerminateDate"
                                        :isValid="isValidTerminateDate"
                                    >
                                    </MdDateTime>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col lg="3" md="3" sm="12">
                                    <MdSelect
                                        v-bind:Label="$t('employee.CosInsAssig')"
                                        v-bind:Options="insuranceList"
                                        v-bind:Model="insuranceSelected"
                                        v-bind:FieldDescription="'description'"
                                        v-bind:FieldCode="'code'"
                                        :IsDisabled="isReadOnlyCosignerInsurance"
                                        v-bind:Multiple="true"
                                        :Input="ChangeDropDownCosignerInsurance"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit
                                        v-model="editableItem.empProv"
                                        v-bind:Label="$t('employee.ProvNum')"
                                        v-bind:isRequired="false"
                                        v-bind:MaxLengthProp="9"
                                        v-bind:Id="'input_e_pro'"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit
                                        v-model="editableItem.npi"
                                        v-bind:Label="'NPI'"
                                        v-bind:isRequired="false"
                                        v-bind:MaxLengthProp="15"
                                        v-bind:Id="'input_e_npi'"
                                    />
                                </b-col>
                                <b-col
                                    md="auto"
                                    lg="auto"
                                    sm="12"
                                    v-if="this.editableItem.emptype === 'D'"
                                >
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.Driver')"
                                        v-bind:Name="'checkbox-Driver'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.isSelfDriver"
                                    />
                                </b-col>
                            </b-row>
                        </div>
                        <!-- END Employee General Info -->

                        <!-- BEGIN TAB DOCUMENT -->
                        <div class="tab-pane fade" id="document" role="tabpanel">
                            <b-row>
                                <div class="col-sm-12 col-md-3">
                                    <MdButton
                                        v-bind:Label="$t('PatientDocument.AddDocument')"
                                        v-bind:ClassProp="
                                            isReadOnly
                                                ? 'btn btn-primary my-3 btn-block'
                                                : 'btn btn-primary my-3 btn-block btn-login'
                                        "
                                        v-bind:IconClass="'ti-plus pr-1'"
                                        v-on:click="CallModalDocument"
                                        v-bind:isReadOnly="this.isReadOnly"
                                    >
                                    </MdButton>
                                </div>
                                <div class="col-sm-12 col-md-9 mb-4">
                                    <div
                                        class="textlabel"
                                        :data-label="this.$t('Shared.SearchElements')"
                                    >
                                        <div class="input-group" dir="ltr">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :dir="dirInput"
                                                v-model="searchDocument"
                                                @keyup.enter="FindDocument"
                                            />
                                            <div class="input-group-append">
                                                <div class="input-group-append">
                                                    <MdButton
                                                        v-bind:Name="'btnsearchinputDocument'"
                                                        v-bind:VariantProp="
                                                            'btn btn-sm search-attached'
                                                        "
                                                        v-bind:IconClass="'mdi mdi-magnify'"
                                                        v-on:click="FindDocument"
                                                    >
                                                    </MdButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-row>
                            <div class="row">
                                <div class="col-md-12">
                                    <MdTablePaginationClient
                                        v-bind:FieldsDate="FieldsDateDocuments"
                                        v-bind:fields="fieldsDocuments"
                                        v-bind:items="documentCodesListFilter"
                                        v-bind:totalRows="totalRowsDocument"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:showMessageIsEmpty="showMessageIsEmptyDocuments"
                                        v-bind:currentPage="currentPageDocument"
                                        v-bind:perPage="perPageDocument"
                                        v-bind:pageOptions="pageOptionsDocument"
                                        v-bind:IsItemReceived="false"
                                        :onRowSelected="onRowSelectedDocument"
                                        :onFiltered="onFilteredDocument"
                                        :pageChanged="pageChangedDocument"
                                        :perPageFunction="PerPageFunctionDocument"
                                        :VisibleDeleteIcon="true"
                                        :deleteIconEvent="RemoveDocument"
                                        :VisibleEditIcon="true"
                                        :editIconEvent="EditDocument"
                                        :RowClick="RowClick"
                                    >
                                    </MdTablePaginationClient>
                                </div>
                            </div>
                        </div>
                        <!-- END TAB DOCUMENT -->

                        <!-- BEGIN TAB DOCUMENT MANAGEMENT -->
                        <div class="tab-pane fade" id="docmgr" role="tabpanel">
                            <b-row>
                                <div class="col-sm-12 col-md-3">
                                    <MdButton
                                        v-bind:Label="$t('PatientDocument.AddDocument')"
                                        v-bind:ClassProp="
                                            isReadOnly
                                                ? 'btn btn-primary my-3 btn-block'
                                                : 'btn btn-primary my-3 btn-block btn-login'
                                        "
                                        v-bind:IconClass="'ti-plus pr-1'"
                                        v-on:click="CallModalDocumentMgr"
                                        v-bind:isReadOnly="this.isReadOnly"
                                    >
                                    </MdButton>
                                </div>
                                <div class="col-sm-12 col-md-9 mb-4">
                                    <div
                                        class="textlabel"
                                        :data-label="this.$t('Shared.SearchElements')"
                                    >
                                        <div class="input-group" dir="ltr">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :dir="dirInput"
                                                v-model="searchDocumentMgr"
                                                @keyup.enter="FindDocumentMgr"
                                            />
                                            <div class="input-group-append">
                                                <div class="input-group-append">
                                                    <MdButton
                                                        v-bind:Name="'btnsearchinputDocument'"
                                                        v-bind:VariantProp="
                                                            'btn btn-sm search-attached'
                                                        "
                                                        v-bind:IconClass="'mdi mdi-magnify'"
                                                        v-on:click="FindDocumentMgr"
                                                    >
                                                    </MdButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-row>
                            <div class="row">
                                <div class="col-md-12">
                                    <MdTablePaginationClient
                                        v-bind:FieldsDate="FieldsDateDocumentMgr"
                                        v-bind:fields="fieldsDocumentMgr"
                                        v-bind:items="documentMgrCodesListFilter"
                                        v-bind:totalRows="totalRowsDocumentMgr"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:showMessageIsEmpty="showMessageIsEmptyDocumentMgr"
                                        v-bind:currentPage="currentPageDocumentMgr"
                                        v-bind:perPage="perPageDocumentMgr"
                                        v-bind:pageOptions="pageOptionsDocumentMgr"
                                        v-bind:IsItemReceived="false"
                                        :onRowSelected="onRowSelectedDocumentMgr"
                                        :onFiltered="onFilteredDocumentMgr"
                                        :pageChanged="pageChangedDocumentMgr"
                                        :perPageFunction="PerPageFunctionDocumentMgr"
                                        :VisibleDeleteIcon="true"
                                        :deleteIconEvent="RemoveDocumentMgr"
                                        :VisibleEditIcon="true"
                                        :editIconEvent="EditDocumentMgr"
                                        :RowClick="RowClick"
                                    >
                                    </MdTablePaginationClient>
                                </div>
                            </div>
                        </div>
                        <!-- END TAB DOCUMENT MANAGEMENT -->

                        <!-- BEGIN TAB PROVIDER -->
                        <div class="tab-pane fade" id="providerid" role="tabpanel">
                            <providerPanel
                                :insuranceList="insuranceList"
                                :isReadOnly="isReadOnly"
                                v-model="editableItem.providerCodesList"
                            >
                            </providerPanel>
                            <!--
                            <b-row>
                                <div class="col-sm-12 col-md-3">                      
                                    <MdButton
                                        v-bind:Label="$t('employee.AddProviderID')" 
                                        v-bind:ClassProp="isReadOnly ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                                        v-bind:IconClass="'ti-plus pr-1'"              
                                        v-on:click="CallModalProvider"
                                        v-bind:isReadOnly="this.isReadOnly">
                                    </MdButton>
                                </div>
                                <div class="col-sm-12 col-md-9 mb-4">
                                    <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                                        <div class="input-group" dir="ltr">
                                            <input 
                                                type="text" 
                                                class="form-control"
                                                :dir="dirInput"
                                                v-model="searchProvider"   
                                                @keyup.enter="FindProvider">
                                            <div class="input-group-append">
                                                <div class="input-group-append">
                                                    <MdButton 
                                                        v-bind:Name="'btnsearchinputProvider'"
                                                        v-bind:VariantProp="'btn btn-sm search-attached'"
                                                        v-bind:IconClass="'mdi mdi-magnify'"
                                                        v-on:click="FindProvider">
                                                    </MdButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-row>
                            <b-row>
                                <div class="col-md-12">
                                    <MdTablePaginationClient 
                                        v-bind:fields="fieldsProvider"
                                        v-bind:items="providerCodesListFilter"
                                        v-bind:totalRows="totalRowsProvider"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:showMessageIsEmpty="showMessageIsEmptyProviders"
                                        v-bind:currentPage="currentPageProvider"
                                        v-bind:perPage="perPageProvider"
                                        v-bind:pageOptions="pageOptionsProvider"  
                                        v-bind:IsItemReceived="false"                    
                                        :onRowSelected="onRowSelectedProvider"
                                        :onFiltered="onFilteredProvider"
                                        :pageChanged="pageChangedProvider"
                                        :perPageFunction="PerPageFunctionProvider" 
                                        :VisibleDeleteIcon="true"
                                        :deleteIconEvent="RemoveProvider"
                                        :VisibleEditIcon="true"
                                        :editIconEvent="EditProvider"
                                        :RowClick="RowClick"
                                    >
                                    </MdTablePaginationClient>
                                </div>
                            </b-row>
                            -->
                        </div>
                        <!-- END TAB PROVIDER -->

                        <!-- BEGIN TAB Signature -->
                        <div class="tab-pane fade" id="signaturecapture" role="tabpanel">
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.CreateMedi')"
                                        v-bind:Name="'checkbox-CreateMedications'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requestSigCreateMed"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('Shared.MARS')"
                                        v-bind:Name="'checkbox-Mars'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requestSigMars"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.ReItems')"
                                        v-bind:Name="'checkbox-ReceivedItems'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requestSigReceivedItems"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.Tars')"
                                        v-bind:Name="'checkbox-RequestSigTars'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requestSigTars"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.FillOrders')"
                                        v-bind:Name="'checkbox-fillorders'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requestSigFillOrders"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.UnFillOrders')"
                                        v-bind:Name="'checkbox-undofillorders'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requestSigUndoFillOrders"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.ItemsRelocation')"
                                        v-bind:Name="'checkbox-RequestSigItemsRelocation'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requestSigItemsRelocation"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.ReturnedItems')"
                                        v-bind:Name="'checkbox-RequestSigReturnItems'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requestSigReturnItems"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.RemovedItems')"
                                        v-bind:Name="'checkbox-RequestSigRemoveItems'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requestSigRemoveItems"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.CreateOrders')"
                                        v-bind:Name="'checkbox-RequestSigCreateORDERS'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requestSigCreateOrders"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdSelect
                                        v-bind:Label="$t('employee.TySign')"
                                        v-bind:Options="signaturePadList"
                                        v-bind:Model="editableItem.signaturePad"
                                        v-bind:FieldDescription="'description'"
                                        v-bind:FieldCode="'code'"
                                        :IsDisabled="false"
                                        v-bind:Multiple="false"
                                        :Input="ChangeDropDownTypeOfSignaturePad"
                                    />
                                </b-col>
                            </b-row>

                            <b-row class="mt-2">
                                <b-col md="5" lg="5" sm="12">
                                    <MdSignature
                                        v-bind:Title="$t('employee.SigEmpl')"
                                        v-bind:Id="'IdCanvasSignatureEmployee'"
                                        v-bind:Data64="editableItem.employeesignature"
                                        :OnlyData="false"
                                        :VisibleSigPad="visibleSigPad"
                                    />
                                </b-col>
                                <b-col md="5" lg="5" sm="12">
                                    <MdSignature
                                        v-bind:Title="$t('employee.empstamp')"
                                        v-bind:Id="'IdCanvasSignatureEmployeeempstamp'"
                                        v-bind:Data64="editableItem.employeestamp"
                                        :OnlyData="false"
                                        :VisibleSigPad="visibleSigPad"
                                    />
                                </b-col>
                            </b-row>
                        </div>
                        <!-- END TAB Signature -->

                        <!-- BEGIN TAB Restriction -->
                        <div class="tab-pane fade" id="restriction" role="tabpanel">
                            <MdTitle
                                v-bind:StyleProp="'margin: 0em 0 0.7em 0'"
                                v-bind:Text="$t('userHeader.EmployeeRestrictionLocation')"
                                v-bind:isSubtitle="true"
                                v-bind:Name="'T_TitleSearch'"
                            />
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.EnforceSeleLoc')"
                                        v-bind:Name="'checkbox-LocationAfterLogin'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requiredLocation"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <div class="col-sm-12 col-md-3">
                                    <MdButton
                                        v-bind:Label="$t('Shared.AddBuilding')"
                                        v-bind:ClassProp="
                                            isReadOnly
                                                ? 'btn btn-primary my-3 btn-block'
                                                : 'btn btn-primary my-3 btn-block btn-login'
                                        "
                                        v-bind:IconClass="'ti-plus pr-1'"
                                        v-on:click="CallModalBuilding"
                                        v-bind:isReadOnly="this.isReadOnly"
                                    >
                                    </MdButton>
                                </div>
                                <div class="col-sm-12 col-md-9 mb-4">
                                    <div
                                        class="textlabel"
                                        :data-label="this.$t('Shared.SearchElements')"
                                    >
                                        <div class="input-group" dir="ltr">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :dir="dirInput"
                                                v-model="searchBuilding"
                                                @keyup.enter="FindBuilding"
                                            />
                                            <div class="input-group-append">
                                                <div class="input-group-append">
                                                    <MdButton
                                                        v-bind:Name="'btnsearchinputBuilding'"
                                                        v-bind:VariantProp="
                                                            'btn btn-sm search-attached'
                                                        "
                                                        v-bind:IconClass="'mdi mdi-magnify'"
                                                        v-on:click="FindBuilding"
                                                    >
                                                    </MdButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-row>
                            <b-row>
                                <div class="col-md-12">
                                    <MdTablePaginationClient
                                        v-bind:fields="fieldsBuilding"
                                        v-bind:items="buildingCodesListFilter"
                                        v-bind:totalRows="totalRowsBuilding"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:showMessageIsEmpty="showMessageIsEmptyBuildings"
                                        v-bind:currentPage="currentPageBuilding"
                                        v-bind:perPage="perPageBuilding"
                                        v-bind:pageOptions="pageOptionsBuilding"
                                        v-bind:IsItemReceived="false"
                                        :onRowSelected="onRowSelectedBuilding"
                                        :onFiltered="onFilteredBuilding"
                                        :pageChanged="pageChangedBuilding"
                                        :perPageFunction="PerPageFunctionBuilding"
                                        :VisibleDeleteIcon="true"
                                        :deleteIconEvent="RemoveBuilding"
                                        :RowClick="RowClick"
                                    >
                                    </MdTablePaginationClient>
                                </div>
                            </b-row>

                            <MdTitle
                                v-bind:StyleProp="'margin: 2em 0 0.7em 0'"
                                v-bind:Text="$t('userHeader.EmployeeRestrictionProgram')"
                                v-bind:isSubtitle="true"
                                v-bind:Name="'T_TitleSearch'"
                            />
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.EnforceSeleProg')"
                                        v-bind:Name="'checkbox-RestrictPatientsshowingbyprogram'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.enforceSelectProgram"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdSelect
                                        v-bind:Label="'Allow To Select'"
                                        v-bind:Options="AllowToSelectOptions"
                                        v-bind:Tag="'EmployeeAllowToSelect'"
                                        v-bind:FieldDescription="'text'"
                                        v-bind:FieldCode="'value'"
                                        v-bind:RequireEvent="true"
                                        v-bind:Model="editableItem.allowSelectMultProg"
                                        v-bind:Multiple="false"
                                        :Input="ChangeDropDownAllowToSelect"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <div class="col-sm-12 col-md-3 col-mb-3 col-lg-3">
                                    <MdButton
                                        v-bind:Label="$t('Shared.AddProgram')"
                                        v-bind:ClassProp="
                                            isReadOnly
                                                ? 'btn btn-primary my-3 btn-block'
                                                : 'btn btn-primary my-3 btn-block btn-login'
                                        "
                                        v-bind:IconClass="'ti-plus pr-1'"
                                        v-on:click="CallModalProgram"
                                        v-bind:isReadOnly="this.isReadOnly"
                                    >
                                    </MdButton>
                                </div>
                                <div class="col-sm-12 col-md-9 col-mb-9 col-lg-9">
                                    <div
                                        class="textlabel"
                                        :data-label="this.$t('Shared.SearchElements')"
                                    >
                                        <div class="input-group" dir="ltr">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :dir="dirInput"
                                                v-model="searchProgram"
                                                @keyup.enter="FindProgram"
                                            />
                                            <div class="input-group-append">
                                                <div class="input-group-append">
                                                    <MdButton
                                                        v-bind:Name="'btnsearchinputProgram'"
                                                        v-bind:VariantProp="
                                                            'btn btn-sm search-attached'
                                                        "
                                                        v-bind:IconClass="'mdi mdi-magnify'"
                                                        v-on:click="FindProgram"
                                                    >
                                                    </MdButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-row>
                            <b-row>
                                <div class="col-md-12">
                                    <MdTablePaginationClient
                                        v-bind:fields="fieldsProgram"
                                        v-bind:items="programCodesListFilter"
                                        v-bind:totalRows="totalRowsProgram"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:showMessageIsEmpty="showMessageIsEmptyPrograms"
                                        v-bind:currentPage="currentPageProgram"
                                        v-bind:perPage="perPageProgram"
                                        v-bind:pageOptions="pageOptionsProgram"
                                        v-bind:IsItemReceived="false"
                                        :onRowSelected="onRowSelectedProgram"
                                        :onFiltered="onFilteredProgram"
                                        :pageChanged="pageChangedProgram"
                                        :perPageFunction="PerPageFunctionProgram"
                                        :VisibleDeleteIcon="true"
                                        :deleteIconEvent="RemoveProgram"
                                        :RowClick="RowClick"
                                    >
                                    </MdTablePaginationClient>
                                </div>
                            </b-row>

                            <MdTitle
                                v-bind:StyleProp="'margin: 2em 0 0.7em 0'"
                                v-bind:Text="$t('userHeader.EmployeeRestrictionPharmacy')"
                                v-bind:isSubtitle="true"
                                v-bind:Name="'T_TitleSearch'"
                            />
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="'Enforce Selecting A Pharmacy After Login'"
                                        v-bind:Name="'checkbox-RestrictPharmacyLocation'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.requiredPharmacyLocation"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <div class="col-sm-12 col-md-3">
                                    <MdButton
                                        v-bind:Label="'Add Pharmacy'"
                                        v-bind:ClassProp="
                                            isReadOnly
                                                ? 'btn btn-primary my-3 btn-block'
                                                : 'btn btn-primary my-3 btn-block btn-login'
                                        "
                                        v-bind:IconClass="'ti-plus pr-1'"
                                        v-on:click="CallModalPharmacy"
                                        v-bind:isReadOnly="this.isReadOnly"
                                    >
                                    </MdButton>
                                </div>
                                <div class="col-sm-12 col-md-9 mb-4">
                                    <div
                                        class="textlabel"
                                        :data-label="this.$t('Shared.SearchElements')"
                                    >
                                        <div class="input-group" dir="ltr">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :dir="dirInput"
                                                v-model="searchPharmacy"
                                                @keyup.enter="FindPharmacy"
                                            />
                                            <div class="input-group-append">
                                                <div class="input-group-append">
                                                    <MdButton
                                                        v-bind:Name="'btnsearchinputPharmacy'"
                                                        v-bind:VariantProp="
                                                            'btn btn-sm search-attached'
                                                        "
                                                        v-bind:IconClass="'mdi mdi-magnify'"
                                                        v-on:click="FindPharmacy"
                                                    >
                                                    </MdButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-row>
                            <b-row>
                                <div class="col-md-12">
                                    <MdTablePaginationClient
                                        v-bind:fields="fieldsPharmacy"
                                        v-bind:items="pharmacyCodesListFilter"
                                        v-bind:totalRows="totalRowsPharmacy"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:showMessageIsEmpty="showMessageIsEmptyPharmacies"
                                        v-bind:currentPage="currentPagePharmacy"
                                        v-bind:perPage="perPagePharmacy"
                                        v-bind:pageOptions="pageOptionsPharmacy"
                                        v-bind:IsItemReceived="false"
                                        :onRowSelected="onRowSelectedPharmacy"
                                        :onFiltered="onFilteredPharmacy"
                                        :pageChanged="pageChangedPharmacy"
                                        :perPageFunction="PerPageFunctionPharmacy"
                                        :VisibleDeleteIcon="true"
                                        :deleteIconEvent="RemovePharmacy"
                                        :RowClick="RowClick"
                                    >
                                    </MdTablePaginationClient>
                                </div>
                            </b-row>

                            <MdTitle
                                v-bind:StyleProp="'margin: 2em 0 0.7em 0'"
                                v-bind:Text="$t('userHeader.EmployeeRestrictionPharmacyRemoval')"
                                v-bind:isSubtitle="true"
                                v-bind:Name="'T_TitleSearch'"
                            />
                            <b-row>
                                <div class="col-sm-12 col-md-3">
                                    <MdButton
                                        v-bind:Label="'Add Pharmacy'"
                                        v-bind:ClassProp="
                                            isReadOnly
                                                ? 'btn btn-primary my-3 btn-block'
                                                : 'btn btn-primary my-3 btn-block btn-login'
                                        "
                                        v-bind:IconClass="'ti-plus pr-1'"
                                        v-on:click="CallModalPharmacyRemoval"
                                        v-bind:isReadOnly="this.isReadOnly"
                                    >
                                    </MdButton>
                                </div>
                                <div class="col-sm-12 col-md-9 mb-4">
                                    <div
                                        class="textlabel"
                                        :data-label="this.$t('Shared.SearchElements')"
                                    >
                                        <div class="input-group" dir="ltr">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :dir="dirInput"
                                                v-model="searchPharmacyRemoval"
                                                @keyup.enter="FindPharmacyRemoval"
                                            />
                                            <div class="input-group-append">
                                                <div class="input-group-append">
                                                    <MdButton
                                                        v-bind:Name="
                                                            'btnsearchinputPharmacyRemoval'
                                                        "
                                                        v-bind:VariantProp="
                                                            'btn btn-sm search-attached'
                                                        "
                                                        v-bind:IconClass="'mdi mdi-magnify'"
                                                        v-on:click="FindPharmacyRemoval"
                                                    >
                                                    </MdButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-row>
                            <b-row>
                                <div class="col-md-12">
                                    <MdTablePaginationClient
                                        v-bind:fields="fieldsPharmacyRemoval"
                                        v-bind:items="pharmacyRemovalCodesListFilter"
                                        v-bind:totalRows="totalRowsPharmacyRemoval"
                                        v-bind:isReadOnly="isReadOnly"
                                        v-bind:showMessageIsEmpty="
                                            showMessageIsEmptyPharmaciesRemoval
                                        "
                                        v-bind:currentPage="currentPagePharmacyRemoval"
                                        v-bind:perPage="perPagePharmacyRemoval"
                                        v-bind:pageOptions="pageOptionsPharmacyRemoval"
                                        v-bind:IsItemReceived="false"
                                        :onRowSelected="onRowSelectedPharmacyRemoval"
                                        :onFiltered="onFilteredPharmacyRemoval"
                                        :pageChanged="pageChangedPharmacyRemoval"
                                        :perPageFunction="PerPageFunctionPharmacyRemoval"
                                        :VisibleDeleteIcon="true"
                                        :deleteIconEvent="RemovePharmacyRemoval"
                                        :RowClick="RowClick"
                                    >
                                    </MdTablePaginationClient>
                                </div>
                            </b-row>

                            <MdTitle
                                v-bind:StyleProp="'margin: 2em 0 0.7em 0'"
                                v-bind:Text="$t('userHeader.EmployeeRestrictionScheduler')"
                                v-bind:isSubtitle="true"
                                v-bind:Name="'T_TitleSearch'"
                            />
                            <b-row>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit
                                        v-bind:Label="'Days Before The Appointment'"
                                        v-bind:Name="'EmployeeDaysBeforeTheAppointment'"
                                        v-bind:TypeProp="'number'"
                                        v-model.number="editableItem.daysBeforeAppt"
                                        v-bind:isReadOnly="false"
                                        v-bind:Id="'input__EmployeeDaysBeforeTheAppointment'"
                                    />
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit
                                        v-bind:Label="'Days After The Appointment'"
                                        v-bind:Name="'EmployeeDaysAfterTheAppointment'"
                                        v-bind:TypeProp="'number'"
                                        v-model.number="editableItem.daysAfterAppt"
                                        v-bind:isReadOnly="false"
                                        v-bind:Id="'input__EmployeeDaysAfterTheAppointment'"
                                    />
                                </b-col>
                                <b-col md="5" lg="5" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="$t('employee.ShowOnly')"
                                        v-bind:Name="
                                            'checkbox-ShowOnlyPatientsAssignedInTheScheduler'
                                        "
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.showOnlyPatientFromScheduler"
                                    />
                                </b-col>
                            </b-row>
                        </div>
                        <!-- END TAB Restriction -->
                    </div>
                </MdTabList>
            </b-col>
        </b-row>

        <!--
        <EmployeeProviderModal
            :visible.sync="visibleProviderModal"
            v-model="editableProvider"
            :insuranceList="insuranceList"
            :editMode="editableItemMode"
            @ok="saveProvider"
        >
        </EmployeeProviderModal>
        -->

        <EmployeeDocumentModal
            :visible.sync="visibleDocumentModal"
            v-model="editableDocument"
            :documentTypeList="documentTypeList"
            :editMode="editableItemMode"
            @ok="saveDocument"
        >
        </EmployeeDocumentModal>

        <EmployeeDocumentMgrModal
            :visible.sync="visibleDocumentMgrModal"
            v-model="editableDocumentMgr"
            :documentTypeList="documentTypeList"
            :editMode="editableItemMode"
            @ok="saveDocumentMgr"
        >
        </EmployeeDocumentMgrModal>

        <ModalTablePaginationServer
            v-bind:Resource="BuildingApiCall"
            v-bind:TypeOption="'Building'"
            @getCodeConditionOK="onCodeConditionOk($event)"
            v-bind:Fields="this.BaseFieldsBuilding"
            v-bind:FieldCode="'code'"
            v-bind:FieldDescription="'name'"
            v-bind:TitleWindow="$t('Shared.AddBuilding')"
            v-bind:ModalId="BuildingDlgId"
        >
        </ModalTablePaginationServer>

        <ModalTablePaginationServer
            v-bind:Resource="ProgramApiCall"
            v-bind:TypeOption="'Program'"
            @getCodeConditionOK="onCodeConditionOk($event)"
            v-bind:Fields="this.BaseFieldsProgram"
            v-bind:FieldCode="'code'"
            v-bind:FieldDescription="'name'"
            v-bind:TitleWindow="$t('Shared.AddProgram')"
            v-bind:ModalId="ProgramDlgId"
        >
        </ModalTablePaginationServer>

        <ModalTablePaginationServer
            v-bind:Resource="PharmacyApiCall"
            v-bind:TypeOption="PharmacyModalType"
            @getCodeConditionOK="onCodeConditionOk($event)"
            v-bind:Fields="this.BaseFieldsPharmacy"
            v-bind:FieldCode="'code'"
            v-bind:FieldDescription="'name'"
            v-bind:TitleWindow="$t('userHeader.EmployeePharmacyTitle')"
            v-bind:ModalId="PharmacyDlgId"
        >
        </ModalTablePaginationServer>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils';
import { EventBus } from '@/event-bus.js';
import EmployeeDocumentModal from './employeeDocumentModal.vue';
import EmployeeDocumentMgrModal from './employeeDocumentMgrModal.vue';
import ProviderPanel from './providerPanel.vue';

export default {
    name: 'EmployeePanel',
    mixins: [ShowMessage, DBFunctions],
    props: {
        value: {
            type: Object,
            required: () => true
        },
        Mode: {
            type: Boolean,
            required: true
        },
        isReadOnly: {
            type: Boolean,
            default: false
        },
        typeList: {
            type: Array,
            required: true
        },
        cellCompanyList: {
            type: Array,
            required: true
        },
        ethnicityList: {
            type: Array,
            required: true
        },
        credentialsList: {
            type: Array,
            required: true
        },
        branchLocationList: {
            type: Array,
            required: true
        },
        signaturePadList: {
            type: Array,
            required: true
        },
        insuranceList: {
            type: Array,
            required: true
        },
        documentTypeList: {
            type: Array,
            required: true
        }
    },
    components: {
        EmployeeDocumentModal,
        EmployeeDocumentMgrModal,
        ProviderPanel
    },

    data() {
        const defaultEmployeeProps = {
            code: '',
            description: '',
            credentials: '',
            firstname: '',
            lastname: '',
            license: '',
            initial: '',
            dayPhone: '',
            nightphone: '',
            address1: '',
            address2: '',
            zip: '',
            beeper: '',
            city: '',
            title: '',
            state: '',
            empProv: '',
            ethcode: '',
            country: '',
            eMail: '',
            status: '',
            county: '',
            pool: '',
            ssn: '',
            textAddress: '',
            needCoSigner: 'N',
            hireddate: null,
            signaturePad: '',
            dob: null,
            sex: '',
            taxonomy: '',
            taxonomyDescription: '',
            cellCompany: '',
            userid: '',
            useridDescription: '',
            branchLocation: '',
            employeeId: '',
            webFormatStamp: '',
            emptype: '',
            terminatedate: null,
            emp_Prov: '',
            employeestamp: '',
            employeestampExt: '',
            npi: '',
            newCropUserType: '',
            employeesignature: '',
            employeesignatureExt: '',
            daysBeforeAppt: 0,
            daysAfterAppt: 0,
            webFormatSignature: '',
            requiredLocation: false,
            allowSelectMultProg: false,
            selectConsInsurances: false,
            insuranceList: null,
            enforceSelectProgram: false,
            showOnlyPatientFromScheduler: false,
            isSelfDriver: false,
            requestSigCreateMed: false,
            requiredPharmacyLocation: false,
            requestSigMars: false,
            requestSigReceivedItems: false,
            requestSigFillOrders: false,
            requestSigUndoFillOrders: false,
            requestSigItemsRelocation: false,
            requestSigCreateCpoe: false,
            requestSigReturnItems: false,
            requestSigRemoveItems: false,
            requestSigCreateOrders: false,
            requestSigTars: false,

            buildingCodesList: [],
            programCodesList: [],
            pharmacyCodesList: [],
            pharmacyRemovalCodesList: [],
            providerCodesList: [],
            documentMgrCodeList: []
        };

        return {
            defaultEmployeeProps: defaultEmployeeProps,
            editableItem: this.value || defaultEmployeeProps,
            tablist: [
                { title: this.$t('Shared.General'), link: '#general', active: true },
                { title: this.$t('employee.Document'), link: '#document' },
                { title: this.$t('employee.DocumentMgr'), link: '#docmgr' },
                { title: this.$t('Shared.ProviderId'), link: '#providerid' },
                { title: this.$t('employee.SigCapture'), link: '#signaturecapture' },
                { title: this.$t('employee.Restriction'), link: '#restriction' }
            ],
            BaseFieldsTaxonomy: [
                { key: 'description', sortable: true, label: this.$t('Shared.Description') },
                { key: 'code', sortable: true, label: this.$t('Shared.Code') }
            ],
            StatusList: EnumService.EmployeeStatus,
            CosignerList: EnumService.CosignerList,
            FieldsDateDocuments: ['expDate'],
            FieldsDateDocumentMgr: ['scanneddate', 'expiration'],
            fieldsDocuments: [
                {
                    key: 'documentName',
                    sortable: true,
                    label: this.$t('employee.Document'),
                    class: 'text-rigth'
                },
                {
                    key: 'expDate',
                    sortable: true,
                    label: this.$t('employee.TerminateDate'),
                    class: 'text-rigth',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'comment',
                    sortable: true,
                    label: this.$t('Shared.Description'),
                    class: 'text-rigth'
                }
            ],
            fieldsDocumentMgr: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('PatientDocument.DocumentType'),
                    class: 'text-rigth'
                },
                {
                    key: 'scanneddate',
                    sortable: true,
                    label: this.$t('HouseFile.FileDate'),
                    class: 'text-rigth',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'expirationDate',
                    sortable: true,
                    label: this.$t('Shared.ExpirationDate'),
                    class: 'text-rigth',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'comments',
                    sortable: true,
                    label: this.$t('Shared.Comments'),
                    class: 'text-rigth'
                },
                {
                    key: 'fileName',
                    sortable: true,
                    label: this.$t('HouseFile.FileName'),
                    class: 'text-rigth'
                }
            ],
            /*fieldsProvider:[
                { key: 'companyName', sortable: true, label: this.$t('employee.Company'), class: 'text-rigth'},
                { key: 'providerId', sortable: true, label: this.$t('Shared.ProviderId'), class: 'text-rigth'}, 
            ],*/
            fieldsBuilding: [
                {
                    key: 'buildingCode',
                    sortable: true,
                    label: this.$t('employee.BuilCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'buildingName',
                    sortable: true,
                    label: this.$t('Shared.BuildingName'),
                    class: 'text-rigth'
                }
            ],
            BaseFieldsBuilding: [
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('employee.BuilCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'name',
                    sortable: true,
                    label: this.$t('Shared.BuildingName'),
                    class: 'text-rigth'
                }
            ],
            fieldsProgram: [
                {
                    key: 'programCode',
                    sortable: true,
                    label: this.$t('Shared.ProgramCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'programName',
                    sortable: true,
                    label: this.$tc('Shared.ProgramName'),
                    class: 'text-rigth'
                }
            ],
            BaseFieldsProgram: [
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('Shared.ProgramCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'name',
                    sortable: true,
                    label: this.$tc('Shared.ProgramName'),
                    class: 'text-rigth'
                }
            ],
            fieldsPharmacy: [
                {
                    key: 'pharmacyCode',
                    sortable: true,
                    label: this.$t('Shared.PharmacyCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'pharmacyName',
                    sortable: true,
                    label: this.$tc('Shared.PharmacyName'),
                    class: 'text-rigth'
                }
            ],
            fieldsPharmacyRemoval: [
                {
                    key: 'pharmacyCode',
                    sortable: true,
                    label: this.$t('Shared.PharmacyCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'pharmacyName',
                    sortable: true,
                    label: this.$tc('Shared.PharmacyName'),
                    class: 'text-rigth'
                }
            ],
            BaseFieldsPharmacy: [
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('Shared.PharmacyCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'name',
                    sortable: true,
                    label: this.$tc('Shared.PharmacyName'),
                    class: 'text-rigth'
                }
            ],
            AllowToSelectOptions: EnumService.EmployeeProgramType,
            GenderList: EnumService.SexsMaleFemaleOnly,
            search: {
                provider: '',
                document: '',
                documentMgr: '',
                building: '',
                program: '',
                pharmacy: '',
                pharmacyRemoval: ''
            },
            searchDocument: '',
            searchDocumentMgr: '',
            //searchProvider: "",
            searchBuilding: '',
            searchProgram: '',
            searchPharmacy: '',
            searchPharmacyRemoval: '',
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            currentPageDocument: 1,
            currentPageDocumentMgr: 1,
            //currentPageProvider: 1,
            currentPageBuilding: 1,
            currentPageProgram: 1,
            currentPagePharmacy: 1,
            currentPagePharmacyRemoval: 1,
            perPageDocument: 10,
            perPageDocumentMgr: 10,
            //perPageProvider: 10,
            perPageBuilding: 10,
            perPageProgram: 10,
            perPagePharmacy: 10,
            perPagePharmacyRemoval: 10,
            pageOptionsDocument: [5, 10, 15],
            pageOptionsDocumentMgr: [5, 10, 15],
            //pageOptionsProvider: [5,10,15],
            pageOptionsBuilding: [5, 10, 15],
            pageOptionsProgram: [5, 10, 15],
            pageOptionsPharmacyRemoval: [5, 10, 15],
            pageOptionsPharmacy: [5, 10, 15],
            isValidDob: true,
            isValidHiredDate: true,
            isValidTerminateDate: true,
            visibleProviderModal: false,
            visibleDocumentModal: false,
            visibleDocumentMgrModal: false,
            visibleBuildingModal: false,
            /*editableProvider: {
                code: '',
                insuranceCode: '',
                providerId: '',
                companyName: ''
            },*/
            editableDocument: {
                employeeCode: '',
                docCode: '',
                recNo: null,
                comment: '',
                expDate: null,
                documentName: ''
            },
            editableDocumentMgr: {
                comments: '',
                description: '',
                doccode: '',
                entitycode: '',
                entitytype: '',
                expirationDate: null,
                extension: '',
                fileName: '',
                sysUser: null,
                IsNew: false,
                Image: ''
            },
            editableBuilding: {
                employeeCode: '',
                buildingCode: '',
                buildingName: ''
            },
            editableProgram: {
                employeeCode: '',
                programCode: '',
                programName: ''
            },
            editablePharmacy: {
                employeeCode: '',
                pharmacyCode: '',
                pharmacyName: ''
            },
            editablePharmacyRemoval: {
                employeeCode: '',
                pharmacyCode: '',
                pharmacyName: ''
            },
            editableItemMode: false,
            BuildingApiCall: 'Buildings?active=true',
            ProgramApiCall: 'Programs',
            PharmacyApiCall: 'PharmacyLocations',
            BuildingDlgId: 'BuildingModalId',
            ProgramDlgId: 'ProgramModalId',
            PharmacyDlgId: 'PharmacyModalId',
            PharmacyModalType: 'Pharmacy',
            isEmployeeTypeValid: true,
            isNeedCosignerValid: true
        };
    },

    watch: {
        value(newValue) {
            this.editableItem = newValue || this.defaultEmployeeProps;
        }
    },

    computed: {
        visibleSigPad() {
            return !!this.editableItem.signaturePad?.length;
        },

        insuranceSelected() {
            const items = this.editableItem.insuranceList?.split(',') || [];
            return this.insuranceList.filter(value => items.some(v => v === value.code));
        },

        isReadOnlyCosignerInsurance() {
            return this.editableItem.needCoSigner !== 'Y';
        },

        isReadOnlyTerminateDate() {
            return this.editableItem.status !== 'T';
        },

        /*providerCodesListFilter() {
            const search = (this.search.provider || '').trim().toLowerCase();
            const list = this.editableItem.providerCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.companyName || '').toLowerCase();
                const id = (item.providerId || '').toLowerCase();
                
                return name.includes(search) || id.includes(search);
            });
        },*/

        documentCodesListFilter() {
            const search = (this.search.document || '').trim().toLowerCase();
            const list = this.editableItem.documentCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.documentName || '').toLowerCase();
                const id = (item.comment || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        documentMgrCodesListFilter() {
            const search = (this.search.documentMgr || '').trim().toLowerCase();
            const list = this.editableItem.documentMgrCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.documentName || '').toLowerCase();
                const id = (item.comment || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        buildingCodesListFilter() {
            const search = (this.search.building || '').trim().toLowerCase();
            const list = this.editableItem.buildingCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.buildingName || '').toLowerCase();
                const id = (item.buildingCode || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        programCodesListFilter() {
            const search = (this.search.program || '').trim().toLowerCase();
            const list = this.editableItem.programCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.programName || '').toLowerCase();
                const id = (item.programCode || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        pharmacyCodesListFilter() {
            const search = (this.search.pharmacy || '').trim().toLowerCase();
            const list = this.editableItem.pharmacyCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.pharmacyName || '').toLowerCase();
                const id = (item.pharmacyCode || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        pharmacyRemovalCodesListFilter() {
            const search = (this.search.pharmacyRemoval || '').trim().toLowerCase();
            const list = this.editableItem.pharmacyRemovalCodesList;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.pharmacyName || '').toLowerCase();
                const id = (item.pharmacyCode || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        /*totalRowsProvider() {
            return this.providerCodesListFilter.length;
        },*/

        totalRowsDocument() {
            return this.documentCodesListFilter.length;
        },

        totalRowsDocumentMgr() {
            return this.documentMgrCodesListFilter.length;
        },

        totalRowsBuilding() {
            return this.buildingCodesListFilter.length;
        },

        totalRowsProgram() {
            return this.programCodesListFilter.length;
        },

        totalRowsPharmacy() {
            return this.pharmacyCodesListFilter.length;
        },

        totalRowsPharmacyRemoval() {
            return this.pharmacyRemovalCodesListFilter.length;
        },

        /*showMessageIsEmptyProviders() {
            return this.totalRowsProvider === 0;
        },*/

        showMessageIsEmptyDocuments() {
            return this.totalRowsDocument === 0;
        },

        showMessageIsEmptyDocumentMgr() {
            return this.totalRowsDocument === 0;
        },

        showMessageIsEmptyBuildings() {
            return this.totalRowsBuilding === 0;
        },

        showMessageIsEmptyPharmacies() {
            return this.totalRowsPharmacy === 0;
        },

        showMessageIsEmptyPharmaciesRemoval() {
            return this.totalRowsPharmacyRemoval === 0;
        },

        showMessageIsEmptyPrograms() {
            return this.totalRowsProgram === 0;
        }
    },

    methods: {
        validate_entries() {
            this.isValidDob =
                Utils.isNullOrEmptyString(this.editableItem.dob) ||
                (Utils.validateBirthDate(this.editableItem.dob) ? true : false);
            this.isValidHiredDate =
                Utils.isNullOrEmptyString(this.editableItem.hireddate) ||
                Utils.isValidDate(this.editableItem.hireddate);
            this.isValidTerminateDate =
                this.isReadOnlyTerminateDate ||
                Utils.isNullOrEmptyString(this.editableItem.terminatedate) ||
                Utils.isValidDate(this.editableItem.terminatedate);
            this.isEmployeeTypeValid = !Utils.isNullOrEmptyString(this.editableItem.emptype);
            this.isNeedCosignerValid = !Utils.isNullOrEmptyString(this.editableItem.needCoSigner);

            return (
                this.isValidDob &&
                this.isValidHiredDate &&
                this.isValidTerminateDate &&
                this.isEmployeeTypeValid &&
                this.isNeedCosignerValid
            );
        },

        ChangeDropDownType(item) {
            this.editableItem.emptype = item ? item.code : '';

            if (this.editableItem.emptype !== 'D') {
                this.editableItem.isSelfDriver = false;
            }
        },

        ChangeDropDownStatus(e) {
            this.editableItem.status = e ? e.value : '';
            if (this.isReadOnlyTerminateDate) {
                this.editableItem.terminatedate = null;
            }
        },

        ChangeDropDownCosigner(value) {
            this.editableItem.needCoSigner = value ? value.value : '';
            this.editableItem.selectConsInsurances = !this.isReadOnlyCosignerInsurance;
            if (this.isReadOnlyCosignerInsurance) {
                this.editableItem.insuranceList = null;
            }
        },

        ChangeDropDownCellCompany(value) {
            this.editableItem.cellCompany = value ? value.code : '';
        },

        ChangeDropDownEthnicity(value) {
            this.editableItem.ethcode = value ? value.code : '';
        },

        ChangeDropDownCredentials(value) {
            this.editableItem.credentials = value ? value.code : '';
        },

        ChangeDropDownCosignerInsurance(value) {
            this.editableItem.insuranceList = value ? value.map(v => v.code).join(',') : null;
            this.editableItem.selectConsInsurances = true;
        },

        ChangeDropDownBranchLocation(value) {
            this.editableItem.branchLocation = value ? value.code : '';
        },

        ChangeDropDownTypeOfSignaturePad(value) {
            this.editableItem.signaturePad = value ? value.code : '';
        },

        ChangeDropDownAllowToSelect(value) {
            this.editableItem.allowSelectMultProg = value ? value.value : '';
        },

        onCodeConditionOk(result) {
            var type = result.FieldName;
            if (type.indexOf('Building') >= 0) {
                this.$bvModal.hide(this.BuildingDlgId);
                if (result.code) {
                    const buildingCode = (result.code || '').toLowerCase();
                    const index = this.editableItem.buildingCodesList.findIndex(item => {
                        const code = (item.buildingCode || '').toLowerCase();

                        return buildingCode === code;
                    });

                    if (index === -1) {
                        this.editableItem.buildingCodesList.push({
                            buildingCode: buildingCode,
                            buildingName: result.description,
                            employeeCode: ''
                        });
                        this.emitChanged('building');
                    }
                }
            } else if (type.indexOf('Program') >= 0) {
                this.$bvModal.hide(this.ProgramDlgId);
                if (result.code) {
                    const programCode = (result.code || '').toLowerCase();
                    const index = this.editableItem.programCodesList.findIndex(item => {
                        const code = (item.programCode || '').toLowerCase();

                        return programCode === code;
                    });

                    if (index === -1) {
                        this.editableItem.programCodesList.push({
                            programCode: programCode,
                            programName: result.description,
                            employeeCode: ''
                        });
                        this.emitChanged('program');
                    }
                }
            } else if (type.indexOf('Pharmacy') >= 0) {
                this.$bvModal.hide(this.PharmacyDlgId);
                if (result.code) {
                    const pharmacyCode = (result.code || '').toLowerCase();
                    const index = this.editableItem.pharmacyCodesList.findIndex(item => {
                        const code = (item.pharmacyCode || '').toLowerCase();

                        return pharmacyCode === code;
                    });

                    if (index === -1) {
                        this.editableItem.pharmacyCodesList.push({
                            pharmacyCode: pharmacyCode,
                            pharmacyName: result.description,
                            employeeCode: ''
                        });
                        this.emitChanged('pharmacy');
                    }
                }
            } else if (type.indexOf('Removal') >= 0) {
                this.$bvModal.hide(this.PharmacyDlgId);
                if (result.code) {
                    const pharmacyCode = (result.code || '').toLowerCase();
                    const index = this.editableItem.pharmacyRemovalCodesList.findIndex(item => {
                        const code = (item.pharmacyCode || '').toLowerCase();

                        return pharmacyCode === code;
                    });

                    if (index === -1) {
                        this.editableItem.pharmacyRemovalCodesList.push({
                            pharmacyCode: pharmacyCode,
                            pharmacyName: result.description,
                            employeeCode: ''
                        });
                        this.emitChanged('pharmacyRemoval');
                    }
                }
            }
        },

        CallModalDocument() {
            this.editableDocument = {
                employeeCode: '',
                docCode: '',
                recNo: null,
                comment: '',
                expDate: null,
                documentName: ''
            };
            this.editableItemMode = false;
            this.visibleDocumentModal = true;
        },

        CallModalDocumentMgr() {
            this.editableDocumentMgr = {
                comments: '',
                description: '',
                doccode: '',
                entitycode: '',
                entitytype: '',
                expirationDate: null,
                extension: '',
                fileName: '',
                scanneddate: null,
                seqno: null,
                sysUser: null,
                IsNew: false,
                Image: ''
            };
            this.editableItemMode = false;
            this.visibleDocumentMgrModal = true;
        },

        /*CallModalProvider(){
            this.editableProvider = {
                code: '',
                insuranceCode: '',
                providerId: '',
                companyName: ''
            };
            this.editableItemMode = false;
            this.visibleProviderModal = true;
        },*/

        CallModalBuilding() {
            this.$bvModal.show(this.BuildingDlgId);
        },

        CallModalProgram() {
            this.$bvModal.show(this.ProgramDlgId);
        },

        CallModalPharmacyRemoval() {
            this.PharmacyModalType = 'Removal';
            this.$bvModal.show(this.PharmacyDlgId);
        },

        CallModalPharmacy() {
            this.PharmacyModalType = 'Pharmacy';
            this.$bvModal.show(this.PharmacyDlgId);
        },

        /*EditProvider(value) {
            this.editableItemMode = true;
            this.editableProvider = value;
            this.visibleProviderModal = true;
        },*/

        EditDocument(value) {
            this.editableItemMode = true;
            this.editableDocument = value;
            this.visibleDocumentModal = true;
        },

        EditDocumentMgr(value) {
            this.editableItemMode = true;
            this.editableDocumentMgr = value;
            this.visibleDocumentMgrModal = true;
        },

        FindDocument() {
            this.search.document = this.searchDocument;
            this.currentPageDocument = 1;
        },

        FindDocumentMgr() {
            this.search.documentMgr = this.searchDocumentMgr;
            this.currentPageDocumentMgr = 1;
        },

        /*FindProvider(){
            this.search.provider = this.searchProvider;
            this.currentPageProvider = 1;
        },*/

        FindBuilding() {
            this.search.building = this.searchBuilding;
            this.currentPageBuilding = 1;
        },

        FindProgram() {
            this.search.program = this.searchProgram;
            this.currentPageProgram = 1;
        },

        FindPharmacyRemoval() {
            this.search.pharmacyRemoval = this.searchPharmacyRemoval;
            this.currentPagePharmacyRemoval = 1;
        },

        FindPharmacy() {
            this.search.pharmacy = this.searchPharmacy;
            this.currentPagePharmacy = 1;
        },

        /*RemoveProvider(itemToRemove){
            this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$tc('Shared.DelRecord'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_provider'
				})
                .then(value => {
                    if (value) {
                        const index = this.editableItem.providerCodesList.findIndex(item => item === itemToRemove);
        
                        if (index !== -1) {
                            this.editableItem.providerCodesList.splice(index, 1);
                            this.emitChanged('provider');
                            
                            if (this.currentPageProvider > (this.totalRowsProvider / this.perPageProvider)) {
                                this.currentPageProvider--;
                            }
                        }
                    }
                });
        },*/

        RemoveDocument(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_document'
                })
                .then(value => {
                    if (value) {
                        const index = this.editableItem.documentCodesList.findIndex(
                            item => item === itemToRemove
                        );

                        if (index !== -1) {
                            this.editableItem.documentCodesList.splice(index, 1);
                            this.emitChanged('document');

                            if (
                                this.currentPageDocument >
                                this.totalRowsDocument / this.perPageDocument
                            ) {
                                this.currentPageDocument--;
                            }
                        }
                    }
                });
        },

        RemoveDocumentMgr(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_document'
                })
                .then(value => {
                    if (value) {
                        const index = this.editableItem.documentMgrCodesList.findIndex(
                            item => item === itemToRemove
                        );

                        if (index !== -1) {
                            this.editableItem.documentMgrCodesList.splice(index, 1);
                            this.emitChanged('documentMgr');

                            if (
                                this.currentPageDocumentMgr >
                                this.totalRowsDocumentMgr / this.perPageDocumentMgr
                            ) {
                                this.currentPageDocumentMgr--;
                            }
                        }
                    }
                });
        },

        RemoveBuilding(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        if (value) {
                            const index = this.editableItem.buildingCodesList.findIndex(
                                item => item === itemToRemove
                            );

                            if (index !== -1) {
                                this.editableItem.buildingCodesList.splice(index, 1);
                                this.emitChanged('building');

                                if (
                                    this.currentPageBuilding >
                                    this.totalRowsBuilding / this.perPageBuilding
                                ) {
                                    this.currentPageBuilding--;
                                }
                            }
                        }
                    }
                });
        },

        RemoveProgram(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        if (value) {
                            const index = this.editableItem.programCodesList.findIndex(
                                item => item === itemToRemove
                            );

                            if (index !== -1) {
                                this.editableItem.programCodesList.splice(index, 1);
                                this.emitChanged('program');

                                if (
                                    this.currentPageProgram >
                                    this.totalRowsProgram / this.perPageProgram
                                ) {
                                    this.currentPageProgram--;
                                }
                            }
                        }
                    }
                });
        },

        RemovePharmacy(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        if (value) {
                            const index = this.editableItem.pharmacyCodesList.findIndex(
                                item => item === itemToRemove
                            );

                            if (index !== -1) {
                                this.editableItem.pharmacyCodesList.splice(index, 1);
                                this.emitChanged('pharmacy');

                                if (
                                    this.currentPagePharmacy >
                                    this.totalRowsPharmacy / this.perPagePharmacy
                                ) {
                                    this.currentPagePharmacy--;
                                }
                            }
                        }
                    }
                });
        },

        RemovePharmacyRemoval(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        if (value) {
                            const index = this.editableItem.pharmacyRemovalCodesList.findIndex(
                                item => item === itemToRemove
                            );

                            if (index !== -1) {
                                this.editableItem.pharmacyRemovalCodesList.splice(index, 1);
                                this.emitChanged('pharmacyRemoval');

                                if (
                                    this.currentPagePharmacyRemoval >
                                    this.totalRowsPharmacyRemoval /
                                        this.PerPageFunctionPharmacyRemoval
                                ) {
                                    this.currentPagePharmacyRemoval--;
                                }
                            }
                        }
                    }
                });
        },

        /*PerPageFunctionProvider(value){
            this.perPageProvider = value;

            if (this.currentPageProvider > (this.totalRowsProvider / this.perPageProvider)) {
                this.currentPageProvider = 1;
            }
        },*/

        PerPageFunctionDocument(value) {
            this.perPageDocument = value;

            if (this.currentPageDocument > this.totalRowsDocument / this.perPageDocument) {
                this.currentPageDocument = 1;
            }
        },

        PerPageFunctionDocumentMgr(value) {
            this.perPageDocumentMgr = value;

            if (this.currentPageDocumentMgr > this.totalRowsDocumentMgr / this.perPageDocumentMgr) {
                this.currentPageDocumentMgr = 1;
            }
        },

        PerPageFunctionBuilding(value) {
            this.perPageBuilding = value;

            if (this.currentPageBuilding > this.totalRowsBuilding / this.perPageBuilding) {
                this.currentPageBuilding = 1;
            }
        },

        PerPageFunctionProgram(value) {
            this.perPageProgram = value;

            if (this.currentPageProgram > this.totalRowsProgram / this.perPageProgram) {
                this.currentPageProgram = 1;
            }
        },

        pageChangedPharmacyRemoval(value) {
            this.perPagePharmacyRemoval = value;

            if (
                this.currentPagePharmacyRemoval >
                this.totalRowsPharmacyRemoval / this.PerPageFunctionPharmacyRemoval
            ) {
                this.currentPagePharmacyRemoval = 1;
            }
        },

        PerPageFunctionPharmacyRemoval(value) {
            this.perPagePharmacyRemoval = value;

            if (
                this.currentPagePharmacyRemoval >
                this.totalRowsPharmacyRemoval / this.perPagePharmacyRemoval
            ) {
                this.currentPagePharmacyRemoval = 1;
            }
        },

        PerPageFunctionPharmacy(value) {
            this.perPagePharmacy = value;

            if (this.currentPagePharmacy > this.totalRowsPharmacy / this.perPagePharmacy) {
                this.currentPagePharmacy = 1;
            }
        },

        /*pageChangedProvider(value){
            this.perPageProvider = value;
        },*/

        pageChangedProgram(value) {
            this.perPageProgram = value;
        },

        pageChangedBuilding(value) {
            this.perPageBuilding = value;
        },

        pageChangedPharmacy(value) {
            this.perPagePharmacy = value;
        },

        pageChangedDocument(value) {
            this.perPageDocument = value;
        },

        pageChangedDocumentMgr(value) {
            this.perPageDocumentMgr = value;
        },

        onRowSelectedDocument() {},

        onRowSelectedDocumentMgr() {},

        /*onRowSelectedProvider(){

        },*/

        onRowSelectedPharmacyRemoval() {},

        onRowSelectedPharmacy() {},

        onRowSelectedBuilding() {},

        onRowSelectedProgram() {},

        onFilteredBuilding() {},

        /*onFilteredProvider(){
        
        },*/

        onFilteredProgram() {},

        onFilteredPharmacy() {},

        onFilteredPharmacyRemoval() {},

        onFilteredDocument() {},

        onFilteredDocumentMgr() {},

        /*saveProvider(value) {
            if (!this.editableItemMode) {
                const insuranceCode = (value.insuranceCode || '').toLowerCase();
                const index = this.editableItem.providerCodesList.findIndex(item => {
                    const code = (item.insuranceCode || '').toLowerCase();
                    
                    return (insuranceCode === code);
                });

                if (index === -1) {
                    this.editableItem.providerCodesList.push(value);
                    this.emitChanged('provider');
                }
            } else {
                const index = this.editableItem.providerCodesList.findIndex(item => item === this.editableProvider);
        
                if (index !== -1) {
                    this.$set(this.editableItem.providerCodesList, index, value);
                    this.emitChanged('provider');
                }
            }
        },*/

        saveDocument(value) {
            if (!this.editableItemMode) {
                this.editableItem.documentCodesList.push(value);
                this.emitChanged('document');
            } else {
                const index = this.editableItem.documentCodesList.findIndex(
                    item => item === this.editableDocument
                );

                if (index !== -1) {
                    this.$set(this.editableItem.documentCodesList, index, value);
                    this.emitChanged('document');
                }
            }
        },

        saveDocumentMgr(value) {
            if (!this.editableItemMode) {
                this.editableItem.documentMgrCodesList.push(...value);
            } else {
                const index = this.editableItem.documentMgrCodesList.findIndex(
                    item => item.seqno === this.editableDocumentMgr.seqno
                );

                if (index !== -1) {
                    this.editableItem.documentMgrCodesList.splice(index, 1);
                }

                const insertIndex =
                    index !== -1 ? index : this.editableItem.documentMgrCodesList.length;
                this.editableItem.documentMgrCodesList.splice(insertIndex, 0, ...value);
            }

            this.emitChanged('documentMgr');
        },

        RowClick() {},

        emitChanged(componentName) {
            const changed = {
                Changed: true,
                ComponentName: componentName
            };

            EventBus.$emit('onChanged', changed);
        },

        setupEventListeners() {
            EventBus.$on('onMouseStop', data => {
                const { img, ext } = Utils.parseBase64Image(data.Image);

                switch (data.Id) {
                    case 'IdCanvasSignatureEmployee':
                        this.editableItem.employeesignature = img;
                        this.editableItem.employeesignatureExt = ext;
                        break;

                    case 'IdCanvasSignatureEmployeeempstamp':
                        this.editableItem.employeestamp = img;
                        this.editableItem.employeestampExt = ext;
                        break;
                }

                this.emitChanged(data.Id);
            });
        },

        cleanupEventListeners() {
            EventBus.$off('onMouseStop');
        }
    },

    mounted() {
        this.setupEventListeners();
    },

    beforeDestroy() {
        this.cleanupEventListeners();
    }
};
</script>
